import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const PageLoader: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ 
            opacity: 0,
            y: -100,
            transition: { duration: 0.8, ease: [0.43, 0.13, 0.23, 0.96] }
          }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-[#FFF5F9] via-white to-[#FFE8F0]"
        >
          <div className="relative flex flex-col items-center">
            {/* Animated Box/Package */}
            <motion.div
              className="relative w-32 h-32"
              animate={{
                rotateY: [0, 360],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "linear"
              }}
              style={{ transformStyle: "preserve-3d" }}
            >
              {/* Box faces */}
              <motion.div
                className="absolute inset-0 bg-gradient-to-br from-[#CA1167] to-[#F47749] rounded-lg shadow-2xl"
                style={{
                  transform: "translateZ(16px)",
                }}
              />
              <motion.div
                className="absolute inset-0 bg-gradient-to-br from-[#F47749] to-[#CA1167] rounded-lg opacity-80"
                style={{
                  transform: "translateZ(-16px) rotateY(180deg)",
                }}
              />
            </motion.div>

            {/* PrintAura Logo */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="mt-8 flex flex-col items-center gap-3"
            >
              <div className="flex items-center gap-2">
                <motion.img
                  src="/Images/PrintAura.webp"
                  alt="PrintAura Icon"
                  className="h-10 w-auto object-contain"
                  animate={{ rotate: [0, 5, -5, 0] }}
                  transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                />
              </div>
              <motion.div
                className="flex gap-1 justify-center"
                animate={{
                  opacity: [0.5, 1, 0.5],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              >
                {/* <span className="text-sm text-gray-600">Loading</span> */}
                <motion.span
                  animate={{ opacity: [0, 1, 0] }}
                  transition={{ duration: 1.5, repeat: Infinity, delay: 0 }}
                >
                  .
                </motion.span>
                <motion.span
                  animate={{ opacity: [0, 1, 0] }}
                  transition={{ duration: 1.5, repeat: Infinity, delay: 0.2 }}
                >
                  .
                </motion.span>
                <motion.span
                  animate={{ opacity: [0, 1, 0] }}
                  transition={{ duration: 1.5, repeat: Infinity, delay: 0.4 }}
                >
                  .
                </motion.span>
              </motion.div>
            </motion.div>

            {/* Printing Press Animation */}
            <motion.div
              className="absolute -bottom-16 left-1/2 transform -translate-x-1/2 flex gap-2"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              {[0, 1, 2, 3].map((i) => (
                <motion.div
                  key={i}
                  className="w-2 h-8 bg-gradient-to-t from-[#CA1167] to-[#F47749] rounded-full"
                  animate={{
                    scaleY: [1, 1.5, 1],
                  }}
                  transition={{
                    duration: 0.8,
                    repeat: Infinity,
                    delay: i * 0.2,
                    ease: "easeInOut"
                  }}
                />
              ))}
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
